export const FETCH_INVOICE_ACTION = "FETCH_INVOICE_ACTION";
export const FETCH_INVOICE_FAIL_ACTION = FETCH_INVOICE_ACTION + "_ERROR";
export const FETCH_INVOICE_SUCCESS_ACTION = FETCH_INVOICE_ACTION + "_SUCCESS";

export const PDF_REPORT_INIT_ACTION = 'PDF_REPORT_INIT_ACTION';
export const PDF_REPORT_SUCCESS_ACTION = PDF_REPORT_INIT_ACTION + '_SUCCESS';
export const PDF_REPORT_FAIL_ACTION = PDF_REPORT_INIT_ACTION + '_ERROR';

export const FETCH_INVOICECONFIGURATION_ACTION = "FETCH_INVOICECONFIGURATION_ACTION";
export const FETCH_INVOICECONFIGURATION_FAIL_ACTION = FETCH_INVOICECONFIGURATION_ACTION + "_ERROR";
export const FETCH_INVOICECONFIGURATION_SUCCESS_ACTION = FETCH_INVOICECONFIGURATION_ACTION + "_SUCCESS";